import styled from 'styled-components';

export default styled.label`
  display: inline-block;
  user-select: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
